import Expertise from "../Home/Expertise";
import ServicesSection from "../Home/ServicesSection";
import About from "../About/About"
import AboutCompany from "./AboutCompany";
import EasySteps from "../Home/EasySetps";


export default function AboutPage() {
  return (
    <>
    <About/>
      <Expertise/>
      <ServicesSection/>
      <EasySteps showSlider={false} />
      <AboutCompany/>
      {/* <DeliveryTeam/> */}
      {/* <Blog/> */}
      
      
    </>
  );
}